import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosHttp from "services/axiosHttp";
import { REWARD_BASE_URL } from "configs/AppConfig";

// Activate user action
export const activateRewardUser = createAsyncThunk("activateRewardUser", async ({ id }, { rejectWithValue }) => {
	try {
		const response = await axiosHttp.get(`${REWARD_BASE_URL}backOffice/user/active?id=${id}`);

		return response.data;
	} catch (error) {
		const errorMessage = error.response?.data?.message || "Something went wrong while activating the user";
		return rejectWithValue(errorMessage);
	}
});

// Deactivate user action
export const deactivateRewardUser = createAsyncThunk("deactivateRewardUser", async ({ id }, { rejectWithValue }) => {
	try {
		const response = await axiosHttp.get(`${REWARD_BASE_URL}backOffice/user/deactive?id=${id}`);
		return response.data;
	} catch (error) {
		const errorMessage = error.response?.data?.message || "Something went wrong while deactivating the user";
		return rejectWithValue(errorMessage);
	}
});
const RewardUserStatusSlice = createSlice({
	name: "RewardUserStatusSlice",
	initialState: {
		isLoading: false,
		isError: false,
		error: null,
		data: null,
	},

	extraReducers: (builder) => {
		// Activate user cases
		builder.addCase(activateRewardUser.pending, (state) => {
			state.isLoading = true;
			state.isError = false;
		});
		builder.addCase(activateRewardUser.fulfilled, (state, action) => {
			state.isLoading = false;
			state.isError = false;
			state.data = action.payload;
		});
		builder.addCase(activateRewardUser.rejected, (state, action) => {
			state.isLoading = false;
			state.isError = true;
			state.error = action.payload;
		});

		// Deactivate user cases
		builder.addCase(deactivateRewardUser.pending, (state) => {
			state.isLoading = true;
			state.isError = false;
		});
		builder.addCase(deactivateRewardUser.fulfilled, (state, action) => {
			state.isLoading = false;
			state.isError = false;
			state.data = action.payload;
		});
		builder.addCase(deactivateRewardUser.rejected, (state, action) => {
			state.isLoading = false;
			state.isError = true;
			state.error = action.payload;
		});
	},
});
export default RewardUserStatusSlice.reducer;
